<p>wifi-setting-status works!</p>
